// extracted by mini-css-extract-plugin
module.exports = {"bottomAnchor":"Password_bottomAnchor__MuEJ7"};